<!--
 * @Description: 拣货表
 * @version: 2
 * @Author: lk
 * @Date: 2019-08-23 15:22:50
 -->
<template>
  <el-dialog v-loading.fullscreen="loading" title="拣货表打印" :visible="visible" width="50%" :show-close="true"
    :close-on-press-escape="false" :close-on-click-modal="false" center @close="$emit('close')">
    <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px;">
      <el-form inline>
        <el-form-item label="打印机选择">
          <el-select v-model="printInfo.printIndex" style="width: 100%;">
            <el-option v-for="item in printers" :key="item.index" :label="item.name" :value="item.index" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-button v-if="$btnsPermission('picking:print')" @click="handlePrint">
        <i class="el-icon-printer"></i>打印
      </el-button>
    </div>

    <div id="printweb" style="background: #f5f5f5; padding: 12px; max-height: 65vh; overflow-y: auto;">
      <div v-for="(item, index) in pickingList" :key="index" style="background: #fff; margin-bottom: 12px; padding: 12px;">
        <div :id="`table${index}`" style="width: 100%;">
          <!-- 标题栏 -->
          <div style="border: 1px solid #000; border-bottom: none; padding: 10px 0; text-align: center; background: #f0f0f0;">
            <span style="font-size: 20px; font-weight: bold; letter-spacing: 8px;">拣 货 单</span>
          </div>

          <!-- 基本信息区 -->
          <div style="display: flex; border: 1px solid #000; border-bottom: none; padding: 10px; align-items: flex-start;">
            <div style="flex-shrink: 0; padding-right: 12px;">
              <img :id="`img${index}`" :src="item.qrCode" style="width: 100px; height: 100px; display: block;" />
            </div>
            <div style="flex: 1; min-width: 0;">
              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">单据编号：</span>
                <span style="flex: 1; word-break: break-all;">{{ item.bizId }}</span>
              </div>

              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">指定发货日期：</span>
                <span style="flex: 1; word-break: break-all;">{{ item.specifyDeliveryDate }}</span>
              </div>
              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">客户：</span>
                <span style="flex: 1; word-break: break-all;">{{ item.recipientInfoVo ? item.recipientInfoVo.customer : '' }}</span>
              </div>
              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">出库客户名称：</span>
                <span style="flex: 1; word-break: break-all;">{{ item.recipientInfoVo ? item.recipientInfoVo.customerName : '' }}</span>
              </div>
              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">仓库名称：</span>
                <span style="flex: 1; word-break: break-all;">{{ getWarehouseName(item) }}</span>
              </div>
              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">销售部门：</span>
                <span style="flex: 1; word-break: break-all;">{{ item.applyOrgName }}</span>
              </div>
              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">出库地址：</span>
                <span style="flex: 1; word-break: break-all;">{{ item.recipientInfoVo ? item.recipientInfoVo.customerAddress : '' }}</span>
              </div>
              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">收件地址：</span>
                <span style="flex: 1; word-break: break-all;">{{ item.recipientInfoVo | formateArea }}</span>
              </div>
              <div style="display: flex; line-height: 22px;">
                <span style="flex-shrink: 0; min-width: 100px;">备注：</span>
                <span style="flex: 1; word-break: break-all;">{{ item.remark }}</span>
              </div>
            </div>
          </div>

          <!-- 商品列表 -->
          <table border="1" cellpadding="6" cellspacing="0" style="width: 100%; border-collapse: collapse; border: 1px solid #000; text-align: left;">
            <thead>
              <tr>
                <th style="padding: 6px; text-align: center; background: #f0f0f0; width: 6%;">编号</th>
                <th style="padding: 6px; text-align: center; background: #f0f0f0; width: 14%;">物料编号</th>
                <th style="padding: 6px; text-align: center; background: #f0f0f0; width: 20%;">物料名称</th>
                <th style="padding: 6px; text-align: center; background: #f0f0f0; width: 18%;">DI码</th>
                <th style="padding: 6px; text-align: center; background: #f0f0f0; width: 14%;">规格型号</th>
                <th style="padding: 6px; text-align: center; background: #f0f0f0; width: 14%;">批号</th>
                <th style="padding: 6px; text-align: center; background: #f0f0f0; width: 14%;">数量</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(info, i) in item.goodsVoList" :key="info.ogoodsId" :style="info.isParent === 'Y' ? 'background: #f5f5f5;' : ''">
                <td style="padding: 6px; text-align: left;">{{ i + 1 }}</td>
                <td style="padding: 6px; text-align: left;">{{ info.goodsCode }}</td>
                <td style="padding: 6px; text-align: left;">{{ info.goodsName }}</td>
                <td style="padding: 6px; text-align: left;">{{ info.diCode }}</td>
                <td style="padding: 6px; text-align: left;">{{ info.specification }}</td>
                <td style="padding: 6px; text-align: left;">{{ info.batchNumber }}</td>
                <td style="padding: 6px; text-align: left;">{{ info.packageNumber }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="7" style="padding: 8px; text-align: right; font-weight: bold;">包装数量合计：{{ item.packageCount }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getPrintPickingOrder, updatePrintStatus } from "@/api/orderManage";
import QRCode from "qrcode";
import { getLodop } from "@/components/print/LodopFuncs";
export default {
  name: "PrintPicking",
  filters: {
    formateArea(value) {
      if (value) {
        const {
          consigneeProvinceName = "",
          consigneeCityName = "",
          consigneeCountyName = "",
          customerAddress = ""
        } = value;
        return `${consigneeProvinceName}${consigneeCityName}${consigneeCountyName}${customerAddress}`;
      }
      return null;
    }
  },
  props: {
    orderIds: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      jobCode: '', // job码
      printStatus: '0', // 打印状态
      number: 0, // 循环次数
      printInfo: {
        printIndex: 4,
        printNum: 1
      },
      printers: [],
      loading: false,
      pickingList: []
    };
  },
  created() {
    setTimeout(() => {
      this.getList();
    }, 1000);
    this.getPrintInfo();
  },
  methods: {
    // 汇总当前订单下所有商品的仓库名称（去重）
    getWarehouseName(item) {
      if (!item || !item.goodsVoList || !item.goodsVoList.length) return ''
      const names = [...new Set(item.goodsVoList.map(g => g.warehouseName).filter(Boolean))]
      return names.join('、')
    },
    // 获取打印机列表
    getList() {
      const LODOP = getLodop();
      if (!LODOP) return;
      let printerNum = LODOP.GET_PRINTER_COUNT();
      let printerList = [];
      for (let index = 0; index < printerNum; index++) {
        printerList.push({ index, name: LODOP.GET_PRINTER_NAME(index) });
      }
      this.printers = printerList;
      let printer = localStorage.getItem(`printer:${this.printerType}`);
      if (printer) {
        this.defaultPrinter = parseInt(printer);
      }
    },
    getPrintInfo() {
      this.pickingList = [];
      this.loading = true;
      getPrintPickingOrder(this.orderIds.join(","))
        .then((res) => {
          if (res.code === "400") {
            this.$message({
              type: "error",
              message: res.msg
            });
          } else {
            this.pickingList = res.data.map((item) => {
              return {
                ...item,
                packageCount: item.goodsVoList.reduce(
                  (a, b) => a + b.packageNumber,
                  0
                )
              };
            });
            res.data.forEach((item, index) => {
              QRCode.toDataURL(item.orderId)
                .then((url) => {
                  this.$set(this.pickingList[index], "qrCode", url);
                })
                .catch((err) => {
                  console.error(err);
                });
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 处理打印
    handlePrint() {
      const LODOP = getLodop();
      const that = this;
      if (!LODOP) return;

      this.pickingList.forEach((item, index) => {
        LODOP.PRINT_INIT("打印出货单");
        // 设置 A4 纸张
        LODOP.SET_PRINT_PAGESIZE(2, 0, 0, "A4");

        const tableEl = document.getElementById(`table${index}`);
        if (!tableEl) return;

        // 直接使用原 DOM 的 innerHTML，并通过 style 标签强制覆盖对齐方式
        const styleOverride = `
          <style>
            #lodop_print_${index} { text-align: left !important; margin: 0 !important; padding: 0 !important; }
            #lodop_print_${index} table { text-align: left !important; border-collapse: collapse !important; }
            #lodop_print_${index} th, #lodop_print_${index} td { text-align: left !important; }
            #lodop_print_${index} th { text-align: center !important; background: #f0f0f0 !important; }
          </style>
        `;
        const printHtml = styleOverride + '<div id="lodop_print_' + index + '" style="text-align: left;">' + tableEl.innerHTML + '</div>';

        // 从页面左上角开始，打印整个内容
        LODOP.ADD_PRINT_HTM("0", "0", "100%", "100%", printHtml);
        // HOrient: 1=左对齐
        LODOP.SET_PRINT_STYLEA(0, "HOrient", 1);

        LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS", true);

        if (LODOP.SET_PRINTER_INDEXA(this.printInfo.printIndex)) {
          LODOP.On_Return = function (TaskID, Value) {
            that.jobCode = Value;
            setTimeout(() => {
              var timer = setInterval(function () {
                if (that.printStatus == '1') {
                  clearInterval(timer);
                  updatePrintStatus({ orderIdList: that.orderIds });
                  that.printStatus = '0';
                  that.jobCode = null;
                  return;
                }
                if (that.number === 25) {
                  clearInterval(timer);
                  that.printStatus = '0';
                  that.jobCode = null;
                }
                that.number++;
                that.getStatusValue(LODOP);
              }, 1000);
            }, 1000);
          };
          LODOP.PRINT();
        }
      });
      this.$message.success('打印命令已发送，请稍后查看');
      this.$emit('close');
    },
    getStatusValue(LODOP) {
      const self = this;
      LODOP.On_Return = function (TaskID, Value) {
        console.log("TaskID:" + TaskID);
        console.log("打印成功状态:" + Value, typeof Value);
        self.printStatus = Value;
      };
      LODOP.GET_VALUE("PRINT_STATUS_OK", this.jobCode);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .gray {
  background: #f5f5f5;
}
</style>
